import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DocumentFile } from '../../models/models';
import { ModalController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { ModalService } from '../../services/modal.service';
import { Errors } from '../../utils/errors';
import { Modal } from '../modal';
import { ContactService } from '../../services/contact.service';
import { PickedFile } from '@capawesome/capacitor-file-picker';

@Component({
  selector: 'app-mail-modal',
  templateUrl: './mail-modal.component.html',
  styleUrls: ['./mail-modal.component.scss'],
})
export class MailModalComponent extends Modal {
  @Input() mail;
  mailForm: FormGroup;
  files: DocumentFile[] = [];
  sendingMail = false;

  constructor(
    modalCtrl: ModalController,
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private contactService: ContactService
  ) {
    super(modalCtrl);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.mailForm = this.formBuilder.group({
      to: new FormControl(this.mail, [Validators.email, Validators.required]),
      subject: new FormControl(null, [Validators.required]),
      message: new FormControl(null, [Validators.required]),
      copy: new FormControl(false, [Validators.required]),
    });
  }

  // addFiles(files: PickedFile[]) {
  //   for (const f of files) {
  //     if (this.files.findIndex(s => s.name === f.name) !== -1) {
  //       continue;
  //     }
  //     this.files.push(new DocumentFile({
  //       name: f.name,
  //       data: f.data,
  //       toBeCompleted: false
  //     }));
  //   }
  // }

  // removeFile(index: number) {
  //   this.files.splice(index, 1);
  // }

  createInsured() {
    if (!this.mailForm.valid) {
      return;
    }
    const data = Object.assign({}, this.mailForm.value);
    data['files'] = this.files;
    this.sendingMail = true;
    this.contactService
      .sendMail(data)
      .then((res) => {
        this.sendingMail = false;
        this.close({ confirm: true });
      })
      .catch((res) => {
        this.sendingMail = false;
        this.modalService.createAlertModal({
          title: 'Oops !',
          message: Errors.getError(res),
        });
      });
  }
}
